import { Label } from '@/view/components/ui/label'
import { Switch } from '@/view/components/ui/switch'
import { useEffect, useState } from 'react'

type SwitchProps = {
  label: string
  defaultValue?: boolean
  value?: boolean
  onChange?: (data: boolean) => void
}

export function SwitchDemo ({ label, value, defaultValue, onChange }: SwitchProps) {
  const [state, setState] = useState<boolean>(value ?? defaultValue ?? false)

  useEffect(() => {
   if(onChange) onChange(state)
  }, [state])

  return (
    <div className='flex items-center space-x-2 '>
      <Label className='flex items-center gap-2 py-1 cursor-pointer'>
        <Switch
          className='bg-cashfit-green-200'
          defaultChecked={defaultValue}
          checked={state}
          onCheckedChange={e => {
            setState(e)
          }}
        />
        {label}
      </Label>
    </div>
  )
}
